module.exports = __webpack_public_path__ + "assets/img/face_contrast_example2.c03c0346.png";